// - This is an alternative to parseQueryNumber where we are most definitely
// not passing in url/query values and can live with the consequences of failure
// - Slightly faster than parseQueryNumber since it has to do less.
export default function parseNonQueryNumber({
  value,
  defaultValue,
}: {
  value: string | string[] | number | undefined
  defaultValue: number
}): number {
  // NOTE: Intentionally not using ?? but || because NaN ?? 0 is still NaN
  return Number.parseInt(`${value}`, 10) || defaultValue
}
